// extracted by mini-css-extract-plugin
export var closeButton = "_a1-0";